const alertsDefaultState = {
    data: [],
    singleAd: {},
    loading: false,
    error: false,
    success: false,
    successMessage: '',
    errorMessage: null
};

const alertsReducer = (state = alertsDefaultState, action) => {
    switch(action.type) {
        case 'START_GET_ALERTS':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
                success: false
            };
        case 'GET_ALERTS_SUCCESS':
            return {
                ...state,
                data: action.alerts,
                loading: false,
                error: false,
                errorMessage: null,
            };
        case 'START_ALERT_UPDATE':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'UPDATE_ALERT_SUCCESS':
            return {
                ...state,
                data: {
                    ...state.data,
                    ...action.alertDetails
                },
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'Microsite has been updated',
            };
        case 'START_REMOVE_ALERTS':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'REMOVE_ALERTS_SUCCESS':
            return {
                ...state,
                data: state.data.filter(ad => { // check original posts and only include posts that don't have that to delete ID
                    return !action.adIds.includes(ad.id); // includes is checking inside an array of numbers to see if any match
                }),
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'Your ads have been removed!',
            };
        case 'ALERT_CLEAR_SUCCESS':
            return {
                ...state,
                success: false
            };
        case 'SHOW_ERROR':
            return {
                ...state,
                loading: false,
                error: true,
                successMessage: '',
                errorMessage: action.errorMessage
            };
        default:
            return state;
    }
};

export default alertsReducer;